export default "__VITE_ASSET__DjBaM4eN__"